import {Box} from "@mui/material"
import React from "react"
import Content from "../../components/Content"

export const containerWidgetGridPrototype = [
    "gridconfiguration",
    {
        key: "justifyContent",
        type: "SELECT",
        label: "justifyContent",
        size: 3,
        options: [
            {
                value: "flex-start",
                label: "flex-start",
            },
            {
                value: "center",
                label: "center",
            },
            {
                value: "flex-end",
                label: "flex-end",
            },
            {
                value: "space-between",
                label: "space-between",
            },
            {
                value: "space-around",
                label: "space-around",
            },
            {
                value: "space-evenly",
                label: "space-evenly",
            },
        ],
    },
    {
        key: "alignItems",
        type: "SELECT",
        label: "alignItems",
        size: 3,
        options: [
            {
                value: "flex-start",
                label: "flex-start",
            },
            {
                value: "center",
                label: "center",
            },
            {
                value: "flex-end",
                label: "flex-end",
            },
            {
                value: "stretch",
                label: "stretch",
            },
            {
                value: "baseline",
                label: "baseline",
            },
        ],
    },
]

const WidgetGrid = ({container, disabled}) => {
    const {children, columncount, alignItems, justifyContent} = container

    return (
        <Box
        width={"100%"}
            sx={{
                alignItems: alignItems,
                justifyContent: justifyContent,
                display: "grid",
                gridTemplateColumns: `repeat(${columncount}, minmax(0, 1fr))`,
                rowGap: container.rowGap ? container.rowGap +"px" : "16px",
                columnGap: container.columnGap ? container.columnGap +"px" : "16px",
                gridAutoRows: "auto",
            }}
        >
            {children?.map(widget => (
                <Box
                    key={widget.id}
                    height={widget.fullHeight ? "100%" : "auto"}
                    bgcolor={widget.background && "#ddddff"}
                    sx={{
                        gridColumn: widget.x + 1 + " /span " + widget.w,
                        gridRow: widget.y + 1 + " /span " + widget.h,
                    }}
                >
                    <Content
                        key={widget.i}
                        child={widget}
                        disabled={disabled}
                    />
                </Box>
            ))}
        </Box>
    )
}

export default WidgetGrid
